module.exports = __webpack_public_path__ + "static/media/1017286.c3bdda4f.jpg";